import { Link } from 'react-router-dom';

export default function StatsSection() {
  return (
    <section className="py-10 md:py-12 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: 'ri-book-open-line', number: '10,000+', label: '漫画资源' },
            { icon: 'ri-user-heart-line', number: '500万+', label: '活跃读者' },
            { icon: 'ri-download-2-line', number: '2000万+', label: 'APP下载量' },
            { icon: 'ri-shield-check-line', number: '99.9%', label: '好评率' },
          ].map((stat, i) => (
            <div key={i} className="text-center p-5 rounded-xl bg-background-50">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">{stat.number}</p>
              <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}